import ChipColors from '@/app/arch/enums/ChipColors';

export default [
  {
    value: 'PESSOA_JURIDICA',
    text: 'Pessoa jurídica',
    ...ChipColors.light,
  },
  {
    value: 'PESSOA_FISICA',
    text: 'Pessoa física',
    ...ChipColors.wait,
  },
];
